<template>
  <div @click="toLearn" class="my-course-item-box">
    <img :src="courseData.thumb" alt class="course-img" />
    <div class="info-box">
      <span class="course-name">{{courseData.courseName}}</span>
      <!-- <span class="course-duration">{{courseData.classCount+"个课时" + ", 当前已观看" +learnCount+"个课时"}}</span> -->
      <span class="course-duration">{{courseData.classCount+"课时"}}</span>
    </div>
    <div class="info-box">
      <div class="course-progress-box">
        <el-progress
          :percentage="learnProgress"
          :stroke-width="16"
          :text-inside="true"
          class="course-progress"
        ></el-progress>
        <span class="duration-text">学习进度</span>
      </div>
      <div class="continue-learn" v-if="learnProgress == 0">开始学习</div>
      <div class="continue-learn" v-if="learnProgress > 0">继续学习</div>
    </div>
  </div>
</template>
<script>
import * as COURSE_API from '@/api/ChannelCourseAPI'
import { Logout } from '@/utils/uni'

export default {
  name: "MyCourseItem",
  props: ['courseData'],
  data () {
    return {
      learnProgress: 0,             //当前学习进度
      learnCount: 0,                //当前学习课时数
    };
  },
  mounted () {
    this.GetLearnProgress()
  },
  methods: {
    toLearn () {
      let data = {
        courseData: this.courseData,
        isRecommend: false
      }
      setTimeout(() => {
        this.$router.push(
          {
            name: 'CourseDetailMobile',
            params: data
          }
        )
        sessionStorage.setItem('h5curriculumSchedule', JSON.stringify(data))
      }, 200)

      //   this.$router.push({ path: "/h5/courseDetail" })
    },
    GetLearnProgress () {
      let data = {
        courseId: this.courseData.courseId
      }
      COURSE_API.GetCourseInfo(data)
        .then(res => {
          if (Number(res.code) === 0) {
            this.learnProgress = parseInt(res.data.progress * 100);
            this.learnCount = res.data.learnCount;
          } else if (data.code === 401) {
            this.$message.error('登录失效，请重新登录')
            // this.$router.push({
            //   name: 'login'
            // })
            Logout()
          } else {
            this.learnProgress = 0
            this.learnCount = 0
          }
        })
    },
  }
}
</script>
<style lang="less" scoped>
.my-course-item-box {
  margin-bottom: 15px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 6px 8px 0px rgba(0, 0, 0, 0.03);
  border-radius: 16px;
  padding-bottom: 20px;
}
.course-img {
  height: 130px;
  width: 100%;
  border-radius: 16px 16px 0 0;
}
.info-box {
  padding: 0 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .course-name {
    font-size: 17px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    line-height: 40px;
    color: rgba(51, 51, 51, 1);
  }
  .course-duration {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 40px;
    color: rgba(158, 158, 158, 1);
  }
  .course-progress-box {
    display: flex;
    width: 75%;
    .course-progress {
      width: 70%;
      color: #000;
    }
    .duration-text {
      margin-left: 5px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(158, 158, 158, 1);
      line-height: 18px;
    }
  }
  .continue-learn {
    width: 68px;
    height: 22px;
    background: linear-gradient(
      161deg,
      rgba(74, 199, 255, 1) 0%,
      rgba(77, 167, 249, 1) 100%
    );
    border-radius: 13px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    line-height: 22px;
    text-align: center;
  }
}
</style>
